import { createContext, Dispatch, MouseEvent, useContext } from 'react';

export interface ZoomContextType {
    x: number | null;
    y: number | null;
    imageToZoomSrc: string | null;
    imageToZoomDimensions: { height: number | null; width: number | null };
    isCursorHovering: boolean;
    setImageToZoomSrc: Dispatch<string>;
    updateCoordinates(event: MouseEvent<HTMLImageElement>): void;
    enableHoveringState: () => void;
    disableHoveringState: () => void;
}

const noop = () => undefined;

export const ZoomContext = createContext<ZoomContextType>({
    x: null,
    y: null,
    imageToZoomDimensions: { height: null, width: null },
    imageToZoomSrc: null,
    isCursorHovering: false,
    setImageToZoomSrc: noop,
    updateCoordinates: noop,
    enableHoveringState: noop,
    disableHoveringState: noop,
});

export const useZoomControls = () => {
    const zoomControls = useContext(ZoomContext);

    return zoomControls;
};
